<template>
    <div class="root" style="display: flex;">
      <div class="one">
        <div class="box" v-for="(item,index) in deailList" :key="index">
              <span>{{ item.title }}</span>
            <el-tooltip class="item" effect="dark" :content="edits[item.attr]" placement="top-start">
              <span>{{edits[item.attr]}}</span>
            </el-tooltip>
          </div>
      </div>
      <div class="two">
        <div class="map-module"></div>
        <bloackMap ref="map" :isShow="false" :height="this.$store.state.windowHeight-340"></bloackMap>
      </div>
    </div>
</template>
  
<script>
  import bloackMap from './block_map.vue'
  import { postFun,getFun,putFun } from "@/utils/httpFun";
  import {operate} from "@/utils/config";
  export default {
    components: {
      bloackMap
    },
    props: {
      operates: {
        type: String,
        default: () => "add",
      },
      edits: {
        type: Object,
        default: () => ({}),
      }
    },
    data() {
      return {
        user:{},
        disabled: false,
        roles: [],
        defaultProps: {
            label: 'showName',
            children: 'structureVos'
        },
        treeData:{},
        canvas:{
            emunid:{},
            projectid:{}
        },
        deailList:[],
        obj:''
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let codeArr = this.edits.longiLatitude.split(",");

        console.log('this',codeArr)
        this.setDeailList()
        let obj = {
          point:{lng:codeArr[0],lat:codeArr[1]},
        }
        this.obj = obj;
        console.log('obj111111111111111111111',this.obj)
        this.$refs.map.getClickInfo(obj,false)
        // this.$$nextTick(()=>{
         
        //   this.$refs.map.success(obj)
        // })
        
      },
      getObj(){
        return this.obj;
      },
      setDeailList(){
        this.deailList.push({title:'项目名称：',attr:'name'})
        this.deailList.push({title:'项目所在地：',attr:'areaAddress'})
        this.deailList.push({title:'项目详址：',attr:'address'})
        this.deailList.push({title:'联系人：',attr:'contacts'})
        this.deailList.push({title:'手机号码：',attr:'phone'})
        this.deailList.push({title:'项目创建时间：',attr:'createTime'})
        this.deailList.push({title:'备注：',attr:'marks'})
      },
      emunClick(emun){
          this.canvas.emunid = emun.id;
          this.canvas.projectid = this.edits.id
          this.$refs.canvas.getProjectImg()
      },
      getCanvas() {
          return this.canvas;
      },
      async threeList(){
          let id = this.edits.id;
          
          await getFun(operate.GETTHREEEMUN+"/"+id,{},res=>{
              
              this.treeData = res.data;
              this.canvas.emunid = this.treeData[0].id
          })
      },
    },
  };
  </script>
  <style lang="scss" scoped>
    .map-module{
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 99;
    }
    .root{
        display: flex;
        flex-wrap: wrap;
        padding-left: 60px;
    }
    .box{
      margin: 10px;
        display: grid;
        font-size: 13px;
        grid-template-columns: 35% 50%;
        span:nth-child(1){
            width: 117px;
            color: #56585C
        }
        span:nth-child(2){
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
    }
    @media screen and (max-width:1160px) {
      .box{
        grid-template-columns: 55% 50%;
      }
    }
    @media screen and (max-width:830px) {
      .box{
        grid-template-columns: 80% 50%;
      }
    }
    // 项目详情
    .one{
      width: 35%;
      float: left;
      display: flex;
      flex-direction: column;
      left: -68px;
      position: relative;
    }
    // 地图
    .two{
      float: right;
      position: relative;
      height: 100%;
      width: 65%;
    }
    // 施工图
    .three{
      height: 400px;
      width: 100%;
      display: flex;
      .three_one{
        height: 100%;
        width: 25%;
      }
      .three_two{
        width: 82%;
        height: 100%;
      }
    }
  </style>
  